import * as Dimensions from '../components/General/Variables';

export const ScreenSize = {
    Phone: `@media(max-width: ${Dimensions.MAX_PHONE})`,
    Tablet: `@media(min-width: ${Dimensions.MIN_TABLET})`,
    Desktop: `@media(min-width: ${Dimensions.MIN_DESKTOP})`,
    DesktopLarge: `@media(min-width: ${Dimensions.MIN_LARGE_DESKTOP})`,
};
